import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subCategoryServices } from '../services/sub-category.service';
import toast from 'react-hot-toast';

export const useToggleSubCategoryStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ categoryId, isActive }) => subCategoryServices.toggleActiveStatus(categoryId, { isActive }),

    onMutate: async ({ categoryId, isActive }) => {
      await queryClient.cancelQueries({ queryKey: ['sub-categories'] });
      const previousData = queryClient.getQueriesData({ queryKey: ['sub-categories'] });

      queryClient.setQueriesData({ queryKey: ['sub-categories'] }, (old) => {
        if (!old) return old;

        return {
          ...old,
          data: old.data?.map((category) => (category._id === categoryId ? { ...category, isActive } : category)),
        };
      });

      return { previousData };
    },

    onError: (error, variables, context) => {
      if (context?.previousData) {
        context.previousData.forEach(([queryKey, data]) => {
          queryClient.setQueryData(queryKey, data);
        });
      }
      toast.error(error?.response?.data?.message || 'Failed to update sub-category status');
    },

    onSuccess: () => {
      toast.success('Sub-category status updated successfully');
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['sub-categories'] });
    },
  });
};
